import React, { useEffect, useRef, useState } from "react";
import "./GlobalSlider.css";

function toNumber(val, fallback) {
  const num = Number(val);
  return Number.isFinite(num) ? num : fallback;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function GlobalSlider({
  name,
  action,
  value,
  min = 0,
  max = 100,
  step = 1,
}) {
  const safeMin = toNumber(min, 0);
  const safeMax = toNumber(max, 100);
  const safeStep = toNumber(step, 1);
  const propValue = clamp(toNumber(value, safeMin), safeMin, safeMax);

  const [localValue, setLocalValue] = useState(propValue);
  const draggingRef = useRef(false);

  useEffect(() => {
    if (!draggingRef.current) {
      setLocalValue(propValue);
    }
  }, [propValue]);

  const emitChange = (numVal) => {
    if (!action) return;
    if (name) {
      action(name, numVal);
    } else {
      action(numVal);
    }
  };

  const handleInput = (event) => {
    draggingRef.current = true;
    const numVal = clamp(toNumber(event.target.value, safeMin), safeMin, safeMax);
    setLocalValue(numVal);
    emitChange(numVal);
  };

  const handlePointerUp = () => {
    draggingRef.current = false;
  };

  const range = safeMax - safeMin || 1;
  const thumbPercent = ((localValue - safeMin) / range) * 100;
  const fillPercent = thumbPercent;

  return (
    <div className="slider custom-labels global-slider-wrap">
      <div className="global-slider-track-area">
        <div className="global-slider-rail">
          <div
            className="global-slider-fill"
            style={{ width: `${fillPercent}%` }}
          />
        </div>
        <input
          type="range"
          className="global-slider-input"
          min={safeMin}
          max={safeMax}
          step={safeStep}
          value={localValue}
          onInput={handleInput}
          onChange={handleInput}
          onMouseUp={handlePointerUp}
          onTouchEnd={handlePointerUp}
          onBlur={handlePointerUp}
          aria-valuemin={safeMin}
          aria-valuemax={safeMax}
          aria-valuenow={localValue}
        />
        <div
          className="global-slider-thumb-label"
          style={{ left: `${thumbPercent}%` }}
          aria-hidden="true"
        >
          {localValue}
        </div>
      </div>
    </div>
  );
}

export default GlobalSlider;
